(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sindhi-gift-contents"] && !Shopify.designMode) return;
  try {
    (function () {
  document.addEventListener('variant:update', function (e) {
    var vid = e.detail && e.detail.resource && e.detail.resource.id;
    if (!vid) return;
    var freshDoc = e.detail && e.detail.data && e.detail.data.html;

    document.querySelectorAll('[data-sgc-block]').forEach(function (el) {
      var blockId = el.dataset.sgcBlock;

      // Fast path: Horizon already fetched the section HTML — extract block from it
      if (freshDoc) {
        var inlined = freshDoc.getElementById('sgc-' + blockId);
        if (inlined) { el.replaceWith(inlined); return; }
      }

      // Fallback: separate SRA fetch for the block's parent section
      var url = window.location.pathname + '?variant=' + vid + '&section_id=' + el.dataset.sgcSection;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('sgc-' + blockId);
        if (fresh) el.replaceWith(fresh);
        // If not found in either path, keep existing content visible
      }).catch(function () {});
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
